import React, { useState, useRef, useCallback, useEffect } from 'react'
import classNames from 'classnames/bind'
import styles from './TableSearch.module.scss'

const cx = classNames.bind(styles)

interface TableSearchProps {
  value?: string
  placeholder?: string
  onChange?: (query: string) => void
}

export default function TableSearch({ value = '', placeholder = 'Search…', onChange }: TableSearchProps) {
  const [local, setLocal] = useState(value)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => { setLocal(value) }, [value])

  const handleChange = useCallback((val: string) => {
    setLocal(val)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => onChange?.(val), 350)
  }, [onChange])

  return (
    <div className={cx('inputIcon')}>
      <span className={cx('ico')}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>
        </svg>
      </span>
      <input
        className={cx('input')}
        type="search"
        placeholder={placeholder}
        value={local}
        onChange={e => handleChange(e.target.value)}
      />
    </div>
  )
}
